import header from "./sketch-of-a-house.webp";
import section1 from "./hausgrundriss-planen.jpg";
import section2 from "./laundry-room.jpg";
import section3 from "./floor-plan-on-tablet.jpg";
import section4 from "./sketch-of-a-room.webp";

export { header, section1, section2, section3, section4 };
